import { createApiReducers, createApiReducerInitialState } from '../../../../Helpers/reducer'

import { SAVE_METADATA } from './metadata.constants'

const initialState = {
  ...createApiReducerInitialState('metadata', {}),
}

export default (state = initialState, action) => {
  const reducers = {
    ...createApiReducers(SAVE_METADATA, 'metadata', {}, true),
  }

  return reducers[action.type] ? reducers[action.type](state, action) : state
}
